<template>
  <div class="autocomplete" :class="[$style.wrapper, {[$style.open]: openSuggestion}]">
    <input :class="$style.code" type="text" v-model="selection" :placeholder="placeholder"
           @keydown.enter = 'enter'
           @keydown.down = 'down'
           @keydown.up = 'up'
           @input = 'change'
           @focus = "focus"
           @blur = 'handleOutsideClick'
    />
    <ul :class="$style.dropdown" class="dropdown-menu">
      <li v-for="(suggestion, index) in matches" :key="suggestion.function"
          :class="{[$style.active]: isActive(index)}"
          class="pointer"
          @click.capture="suggestionClick(index)"
          @mouseover="current = index"
      >
        <a href="#" class="pointer">{{ suggestion.function }}{{ $mq === 'sm' ? ` – ${suggestion.translation}` : '' }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'autocomplete',
  props: {
    suggestions: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
      required: true,
      twoWay: true,
    },
    placeholder: {
      type: String,
    },
    close: {
      type: Boolean,
    },
  },
  data() {
    return {
      selection: '',
      open: false,
      current: 0,
    }
  },
  computed: {
    matches() {
      if (this.$mq === 'sm' && this.selection === '') {
        return this.suggestions
      }
      return this.suggestions.filter(str => str.function.indexOf(this.selection.toLowerCase()) >= 0)
    },
    openSuggestion() {
      return (this.selection !== '' || this.$mq === 'sm')
        && this.matches.length !== 0
        && this.open
        && !this.close
    },
  },
  watch: {
    selection() {
      this.$emit('input', this.selection)
    },
    value() {
      this.selection = this.value
    },
  },
  methods: {
    enter() {
      this.selection = this.matches[this.current].function
      this.open = false
    },
    up() {
      if (this.current > 0) this.current -= 1
    },
    down() {
      if (this.current < this.matches.length - 1) this.current += 1
    },
    isActive(index) {
      return index === this.current
    },
    change() {
      if (this.open === false) {
        this.open = true
        this.current = 0
      }
    },
    suggestionClick(index) {
      this.selection = this.matches[index].function
      this.open = false
    },
    handleOutsideClick() {
      setTimeout(() => { this.open = false }, 1000)
    },
    focus() {
      if (this.$mq === 'sm') {
        this.open = true
      }
      this.$emit('focus')
    },
  },
  mounted() {
    this.selection = this.value
  },
}
</script>

<style lang="scss" module>
  .wrapper {
    display: inline-flex;
    position: relative;
    width: 100%;
    height: 4rem;
    @media #{$m-mobile} {
      height: 5rem;
    }
  }
  .code,
  .dropdown {
    width: 100%;
    color: white;
    background-color: inherit;
    border:none;
    outline:none;
    -webkit-text-fill-color: white;
    resize: none;
    overflow: auto;
  }
  .dropdown {
    display: none;
    position: absolute;
    top: 2rem;
    width: 100%;
    background-color: #000;
    color: white;
    z-index: 2;
    border-radius: 1rem;
    padding: 0;
    li {
      padding-left: 1rem;
      padding-right: 1rem;
      line-height: 2;
      &:hover, &.active {
        background-color: #262727;
      }
      &::marker {
        content: none;
      }
      a {
        color: white;
        text-decoration: unset;
      }
    }
  }
  .open .dropdown {
    display: block;
  }
</style>
